import script from "./MerchantLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./MerchantLogin.vue?vue&type=script&setup=true&lang=js"

import "./MerchantLogin.vue?vue&type=style&index=0&id=298a0b0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-298a0b0a"]])

export default __exports__